import styled from "styled-components";
import { NavLink } from "react-router-dom";

export const Trail = styled.nav`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: ${({ theme }) => theme.textSecondary};
  min-width: 0;
  overflow: hidden;
`;

export const Crumb = styled.span`
  display: inline-flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Separator = styled.span`
  display: inline-flex;
  color: ${({ theme }) => theme.textTertiary || theme.textSecondary};
  opacity: 0.6;
  flex-shrink: 0;
`;

export const CrumbLink = styled(NavLink)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: ${({ theme }) => theme.textSecondary};
  text-decoration: none;
  padding: 2px 6px;
  border-radius: 4px;
  transition: color 0.12s ease, background 0.12s ease;

  &:hover {
    color: ${({ theme }) => theme.accent};
    background: ${({ theme }) => theme.surfaceAlt};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.accent};
    outline-offset: 1px;
  }
`;

export const CrumbText = styled.span`
  padding: 2px 6px;
  color: ${({ theme, $muted }) =>
    $muted ? theme.textSecondary : theme.textPrimary};
  font-weight: ${({ $muted }) => ($muted ? 400 : 600)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 280px;
`;
